import { memo } from "react";

import { BentoBoxCardPlaceholder } from "@react/sections/BentoBox/BentoBoxCard/BentoBoxCardPlaceholder.view";
import { styles } from "@react/sections/BentoBox/BentoBoxCards/BentoBoxCardsLayoutA.data";
import { type BentoBoxCardProps } from "@root/tablescape/state/bentoBox";
import { tw } from "classnames";

type Props = {
  cards: BentoBoxCardProps[];
};

const BentoBoxCardsLayoutAPlaceholderBase = ({ cards }: Props) => {
  return (
    <div className={tw(styles.base, "animate-pulse")}>
      {cards.map((card, index) => {
        return (
          <BentoBoxCardPlaceholder
            {...card}
            className={styles.card(index)}
            key={`bento-box_layout-a_card-${index}`}
          />
        );
      })}
    </div>
  );
};

export const BentoBoxCardsLayoutAPlaceholder = memo(
  BentoBoxCardsLayoutAPlaceholderBase
);
